import vinValidator from '@vroomlabs/vin-validate';

export const isValidVin = (vin) => {
  const checkDigit = vinValidator.checkDigitFromVin(vin);
  if (checkDigit !== vin[8]) {
    return false;
  }
  return vinValidator.vinValidate(vin);
};
